<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-15 15:10:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-21 14:22:37
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="plate">
        <div class="title-wrap">
          <h2 class="title">
            <span
              class="txt"
              style="font-size: 20px"
              :title="detail.cooperativeName"
              >{{ detail.cooperativeName }}</span
            >
          </h2>
        </div>
        <div class="panel-one">
          <p class="item" :title="detail.socialCreditCode">
            <img src="~@/assets/icon_credit_code.png" width="18" alt="" />
            统一社会信用代码：{{ detail.socialCreditCode }}
          </p>
          <p class="item" :title="detail.address">
            <img src="~@/assets/icon_address.png" width="18" alt="" />
            经营地址：{{ detail.address }}
          </p>
        </div>
        <div class="panel-two" style="margin-top: 5px">
          <div class="title-wrap vertical-line">
            <h2 class="title">
              <span class="txt" style="font-size: 16px">合作社基本信息</span>
            </h2>
          </div>
          <ul class="list">
            <li class="item">
              <img src="~@/assets/icon_01.png" alt="" />
              <p class="name">成立时间</p>
              <p class="value" :title="detail.foundingTime">
                {{ detail.foundingTime }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_02.png" alt="" />
              <p class="name">法定代表人</p>
              <p class="value" :title="detail.corName">{{ detail.corName }}</p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_03.png" alt="" />
              <p class="name">成员出资总额</p>
              <p class="value" :title="detail.registeredCapitalCh">
                {{ detail.registeredCapitalCh }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_04.png" alt="" />
              <p class="name">种植作物</p>
              <p
                class="value"
                :title="detail.cropCodeNameList | formatCropCodeNameList"
              >
                {{ detail.cropCodeNameList | formatCropCodeNameList }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_05.png" alt="" />
              <p class="name">机具数量（台）</p>
              <p class="value" :title="detail.machineNums">
                {{ detail.machineNums }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_06.png" alt="" />
              <p class="name">机手数量（人）</p>
              <p class="value" :title="detail.driverNums">
                {{ detail.driverNums }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="plate">
        <div class="panel-two">
          <div class="title-wrap vertical-line">
            <h2 class="title">
              <span class="txt" style="font-size: 16px">理事长基本信息</span>
            </h2>
          </div>
          <ul class="list" v-if="detail.directorDto">
            <li class="item">
              <img src="~@/assets/icon_07.png" alt="" />
              <p class="name">理事长</p>
              <p class="value" :title="detail.directorDto.directorName">
                {{ detail.directorDto.directorName }}
              </p>
            </li>
            <li class="item">
              <el-image
                :src="
                  headUrl ? headUrl : require('@/assets/icon_avatar_01.png')
                "
                :preview-src-list="headUrlList"
                style="width: 120px; height: 120px"
              >
                :
                <span slot="error">
                  <el-image
                    :lazy="true"
                    fit="cover"
                    :src="require('@/assets/icon_avatar_01.png')"
                    style="width: 120px; height: 120px"
                  >
                  </el-image>
                </span>
              </el-image>
            </li>
            <li class="item">
              <img src="~@/assets/icon_08.png" alt="" />
              <p class="name">身份证号</p>
              <p class="value" :title="detail.directorDto.idCard">
                {{ detail.directorDto.idCard }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_09.png" alt="" />
              <p class="name">手机号码</p>
              <p class="value" :title="detail.directorDto.mobile">
                {{ detail.directorDto.mobile }}
              </p>
            </li>
            <li class="item">
              <img src="~@/assets/icon_10.png" alt="" />
              <p class="name">住址</p>
              <p class="value" :title="detail.directorDto.address">
                {{ detail.directorDto.address }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="side-wrap">
        <div class="plate left-side">
          <el-tabs v-model="activeNameLeft">
            <el-tab-pane label="营业执照" name="first">
              <ul class="list">
                <li class="item">
                  <el-image
                    v-if="businessLicenseUrl"
                    :src="businessLicenseUrl"
                    :preview-src-list="businessLicenseUrlList"
                  >
                    <span slot="error">
                      <el-image
                        :lazy="true"
                        fit="cover"
                        :src="require('@/assets/upimg_failure.png')"
                      >
                      </el-image>
                    </span>
                  </el-image>
                </li>
              </ul>
            </el-tab-pane>
            <!-- <el-tab-pane label="理事长照片" name="second">
              <ul class="list">
                <li class="item">
                  <el-image
                    v-if="headUrl"
                    :src="headUrl"
                    :preview-src-list="headUrlList"
                  >
                  </el-image>
                </li>
              </ul>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <div class="plate right-side">
          <el-tabs v-model="activeNameRight">
            <el-tab-pane label="荣誉证书" name="first">
              <ul class="list">
                <li
                  class="item"
                  v-for="(item, index) in honorList"
                  :key="index"
                >
                  <el-image
                    v-if="index < 4"
                    :src="item.picPath"
                    :preview-src-list="honorPreviewList"
                    :fit="'contain'"
                  >
                    <span slot="error">
                      <el-image
                        :lazy="true"
                        fit="cover"
                        :src="require('@/assets/upimg_failure.png')"
                      >
                      </el-image>
                    </span>
                  </el-image>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="plate">
        <el-tabs v-model="activeName">
          <el-tab-pane label="机具信息" name="first"
            ><CooperativeMachines :accountId="masterId"></CooperativeMachines
          ></el-tab-pane>
          <el-tab-pane label="流转信息" name="second"
            ><CooperativeCirculationInfo></CooperativeCirculationInfo
          ></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-main>
</template>

<script>
import CooperativeMachines from "./components/CooperativeMachines";
import CooperativeCirculationInfo from "./components/CooperativeCirculationInfo";
import { mapState, mapActions } from "vuex";
export default {
  name: "BasicInfoHome",
  components: {
    CooperativeMachines,
    CooperativeCirculationInfo,
  },
  data() {
    return {
      isRequest: false,
      detail: {},
      honorList: [],
      activeName: "first",
      activeNameLeft: "first",
      activeNameRight: "first",
      masterId: "",
    };
  },
  filters: {
    formatCropCodeNameList: function (value) {
      if (value) {
        return value.join("，");
      } else {
        return "";
      }
    },
  },
  computed: {
    businessLicenseUrl() {
      return this.detail.businessLicenseUrl || "";
    },
    businessLicenseUrlList() {
      let pics = [];
      if (this.detail.businessLicenseUrl) {
        pics = this.detail.businessLicenseUrl.split(",");
      }
      return pics;
    },
    headUrl() {
      return this.detail.directorDto && this.detail.directorDto.headUrl
        ? this.detail.directorDto.headUrl
        : "";
    },
    headUrlList() {
      let pics = [];
      if (this.detail.directorDto && this.detail.directorDto.headUrl) {
        pics = this.detail.directorDto.headUrl.split(",");
      }
      return pics;
    },
    honorPreviewList() {
      let cooFileDtoList = this.detail.cooFileDtoList,
        tempAry = [];
      if (cooFileDtoList && cooFileDtoList.length > 0) {
        this.detail.cooFileDtoList.forEach((item) => {
          tempAry.push(item.picPath);
        });
      }
      return tempAry;
    },
  },
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.queryCoosByMasterId(this.masterId);
  },
  methods: {
    /**
     * @descripttion: 获取合作社基本信息
     * @Author: juanjuanhui
     * @Date: 2021-11-22 10:19:54
     * @param {*}
     */
    queryCoosByMasterId(accountId) {
      this.$http.basicInfo.queryCoosByMasterId({ accountId }).then((res) => {
        let { cooFileDtoList } = res.data;
        res.data.cropCodeNameList = res.data.cropCodeNameList
          ? res.data.cropCodeNameList
          : [];
        this.detail = res.data;
        this.isRequest = true;
        if (cooFileDtoList && cooFileDtoList.length > 0) {
          this.honorList = this.detail.cooFileDtoList.filter((item) => {
            return item.fileType == 2;
          });
          this.honorList = this.honorList.slice(0, 4);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
@import "@/styles/common.scss";
.main {
  padding: 0 !important;
  background: #f1f3f8 !important;
  .plate {
    padding: 10px 16px 16px;
    margin-bottom: 16px;
    background: #fff;
    .title-wrap {
      @include plate-title-mutil;
      border-bottom: none;
      .txt {
        font-size: 16px;
      }
    }
    .panel-one {
      display: flex;
      margin-top: 5px;
      .item {
        color: #888888;
        &:first-child {
          margin-right: 50px;
        }
      }
    }
    .panel-two {
      .list {
        display: flex;
        .item {
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items: center;
          width: 16.6666%;
          padding: 0 10px;
          border-right: 1px solid #dfe7eb;
          box-sizing: border-box;
          &:last-child {
            border-right: none;
          }
          .name {
            line-height: 22px;
            font-size: 14px;
            margin-top: 6px;
            color: #9a9a9a;
          }
          .value {
            width: 100%;
            font-size: 16px;
            color: #444444;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .side-wrap {
    display: flex;
    justify-content: space-between;
    .plate {
      flex: 1;
      &:first-child {
        margin-right: 16px;
      }
    }
    .left-side,
    .right-side {
      .list {
        display: flex;
        .item {
          width: 160px;
          height: 180px;
          margin-right: 10px;
          border: solid 1px #dfdfdf;
          .el-image {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    ::v-deep .el-tabs__nav-wrap {
      .el-tabs__nav {
        .el-tabs__item {
          padding-right: 0;
        }
      }
    }
  }

  ::v-deep {
    .el-tabs__nav-wrap {
      .el-tabs__nav {
        margin-top: 10px;
      }
    }
  }
}
</style>
